module.exports = __webpack_public_path__ + "img/0-lg.f03479eb.jpg";